import { Component, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { DriverRouteService } from '@services/driver-route/driver-route.service';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-driver',
    templateUrl: './driver.component.html',
    styleUrls: ['./driver.component.scss'],
    providers: [DriverRouteService],
    standalone: false
})

export class DriverComponent implements OnInit {
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  public title = 'Driver Routes';
  public pageActions: PageAction[];
  public columns = [{ prop: 'path' }];
  public searchColumns = [{ prop: 'path' }];

  constructor(public driverService: DriverRouteService, private router: Router, private dialogService: DialogService) {
  }

  ngOnInit() {
    this.pageActions = [
      new PageAction({
        icon: 'add',
        title: 'Create Route',
        callback: () => {
          this.router.navigate(['driver/create']);
        }
      })
    ];
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate(['driver', event.row._id, 'edit']);
  }

  public async onRemove(event: DataTableEvent) {
    const res = await this.dialogService.confirm('Diese Driver Route wirklich löschen?')
    if (!res) {
      return;
    }
    await this.driverService.remove(event.row._id);
    this.dataTable.refresh();
  }

}
